import { useEffect } from "react";
import { useData } from "@/stores/data";
import { useModal } from "@/stores/modal";
import { ExportModal } from "./ExportModal";

export default function Export() {
  const { currentExport, setCurrentExport } = useData();
  const open = useModal((state) => state.open);
  const close = useModal((state) => state.close);
  const isModalOpen = useModal((state) => state.content.state);

  useEffect(() => {
    if (!isModalOpen && currentExport != "") {
      setCurrentExport("");
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (currentExport != "") {
      open({
        html: (
          <ExportModal
            currentExport={currentExport}
            close={close}
            setCurrentExport={setCurrentExport}
          />
        ),
        width: "500",
        state: true,
        position: "center",
      });
    }
  }, [currentExport]);

  return null;
}
